import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '@agilepoint/wat-react';
import { ResetDefaultSettingsContainer } from '../containers';
import { StyledPrimaryButton, StyledStackPanel } from 'common';

interface ITabFooterButtonProps {
    mutationLoading?: boolean;
    onSubmitClickHandler: () => void;
}

const FooterBlock = styled(StyledStackPanel)`
    border-top: 1px solid ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    padding-top: 20px;
    box-sizing: border-box;
`;

export const TabFooterButtons = React.memo((props: ITabFooterButtonProps) => {
    const { mutationLoading, onSubmitClickHandler } = props;
    const translate = useTranslate();

    return (
        <FooterBlock gap="25" justifyContent="flex-end" width="100%">
            <ResetDefaultSettingsContainer />
            <StyledPrimaryButton label={translate('common.actions.save')} onClick={onSubmitClickHandler} disabled={mutationLoading} />
        </FooterBlock>
    );
});
